var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F27067",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F27067",
    fillRule: "evenodd",
    d: "m10.136 18.91 8.773-8.774c.213-.213.6-.171.863.092.263.264.305.65.091.863l-8.772 8.772c-.213.214-.6.172-.863-.09-.263-.264-.305-.651-.091-.864Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F27067",
    fillRule: "evenodd",
    d: "m11.09 10.136 8.773 8.773c.214.213.172.6-.09.863-.264.263-.651.305-.864.091l-8.772-8.772c-.214-.213-.172-.6.09-.863.264-.263.651-.305.864-.091Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F27067",
    strokeWidth: 0.5,
    d: "m10.136 18.91 8.773-8.774c.213-.213.6-.171.863.092.263.264.305.65.091.863l-8.772 8.772c-.213.214-.6.172-.863-.09-.263-.264-.305-.651-.091-.864Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F27067",
    strokeWidth: 0.5,
    d: "m11.09 10.136 8.773 8.773c.214.213.172.6-.09.863-.264.263-.651.305-.864.091l-8.772-8.772c-.214-.213-.172-.6.09-.863.264-.263.651-.305.864-.091Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.e338e06c8cfada1b2cbbfa371ae67d82.svg";
export { ForwardRef as ReactComponent };